module.exports = __webpack_public_path__ + "static/GridColumn-0a64469e233af891b53852074dc0867f.png";